var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 20,
  viewBox: "0 0 14 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80.597)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M92.328,12.877C94.749,4.167,94.6,4.8,94.6,4.546a1.315,1.315,0,0,0-.429-.965A1.413,1.413,0,0,0,92,3.9V1.5a1.557,1.557,0,0,0-3.111,0V5.971L86.3,1.833a1.567,1.567,0,0,0-1.349-.75A1.5,1.5,0,0,0,83.6,3.333L85.885,7H82.844a1.529,1.529,0,0,0-1.556,1.5c0,.183.023.167,0,.167a.681.681,0,0,0-.691.667v6A4.756,4.756,0,0,0,85.436,20h1.729a4.253,4.253,0,0,0,2.843-1.179,7.512,7.512,0,0,0,2.32-5.945ZM87.54,13.946a1.444,1.444,0,0,1-2.3.642,4.26,4.26,0,0,1-1.531-3.254A2.6,2.6,0,0,0,83.475,10H86.46l.383.336a2.2,2.2,0,0,1,.755,1.649,7.376,7.376,0,0,1-.058,1.96Z",
  transform: "translate(0)",
  fill: "#f9cfac"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(81.267 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M282.024,1.513v8.665A61.709,61.709,0,0,0,279,4.766V1.513a1.513,1.513,0,1,1,3.027,0Z",
  transform: "translate(-271.313 0)",
  fill: "#ffe4cc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.385,34.458l-.906-.906a4.655,4.655,0,0,0-3.314-1.373h-.637L147.7,29.131a1.513,1.513,0,1,1,2.621-1.513C153.353,32.63,152.448,31.1,154.385,34.458Z",
  transform: "translate(-145.316 -25.767)",
  fill: "#ffe4cc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.82,179.5a8.639,8.639,0,0,0-.378-2.063l-2.8-2.8a4.036,4.036,0,0,0-2.854-1.182c-3.493,0-3.46-.054-3.885.162a1.515,1.515,0,0,0-.755.871,3,3,0,0,1,2.753,1.994h2.2a3.029,3.029,0,0,1,.915,1.094c.25.565.192.883.192,2.493a1.385,1.385,0,0,1-2.3,1.042,4.363,4.363,0,0,1-1.371-2.271c-.273-1.144.1-1.637-.459-2.567a2.354,2.354,0,0,0-1.807-1.127l-.2-.009c-.017,0-.011-.463-.011,6.055a4.709,4.709,0,0,0,4.708,4.708h1.682a4.061,4.061,0,0,0,2.468-.919h0A7.765,7.765,0,0,0,107.82,179.5Z",
  transform: "translate(-97.071 -166.576)",
  fill: "#ffe4cc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M371.267,81.017c0,.251.123-.282-1.87,7.153V79.778A1.347,1.347,0,0,1,371.267,81.017Z",
  transform: "translate(-357.939 -76.483)",
  fill: "#ffe4cc"
})))));
export default __webpack_public_path__ + "static/media/feature.a5d9d7d9.svg";
export { SvgComponent as ReactComponent };